import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";

export interface IBillingCycleClinic {
  _id: string;
  name: string;
  uploadFolder: string[];
}

export interface IBillingCyclePatient {
  _id: string;
  name: string;
  rtmStatus: string;
  dobString: string;
  phone: string;
  billingProviderId: IBillingCycleProvider;
  associatedClinicId: IBillingCycleClinic;
  uploadFolder: string[];
}

export interface IBillingCycleProvider {
  _id: string;
  name: string;
}

export interface IBillingCyclePlan {
  _id: string;
  name: string;
}

export interface IBillingCycleData {
  billStatus: string;
  _id: string;
  patientId: IBillingCyclePatient;
  billingProviderId: IBillingCycleProvider;
  address: string;
  planId: IBillingCyclePlan;
  billingCycleStartDate: string;
  billingCycleEndDate: string;
  consentDate: string;
}

export interface IBillingCycleRes {
  status: "success" | "fail";
  msg: string;
  data: IBillingCycleData;
}

const useFetchBillingCycle = (billingCycleId: string) => {
  const [billingCycleData, setBillingCycleData] =
    React.useState<IBillingCycleData | null>(null);

  const { loading: billingCycleLoading, makeApiCall } = useApi({
    url: `/rtm/patient-dashboard/pdf/v3/billing-cycle/${billingCycleId}`,
    method: "GET",
  });

  const getBillingCycleData = async () => {
    if (!billingCycleId) return;

    try {
      const { response } = await makeApiCall<undefined, IBillingCycleRes>();

      if (response?.status === "success") {
        setBillingCycleData(response.data);
      } else {
        setBillingCycleData(null);
        // toast.error(response?.msg || "Failed to load billing cycle data. Please try again.");
      }
    } catch (error: any) {
      console.error("Error fetching billing cycle data:", error);
      setBillingCycleData(null);
      // toast.error(error?.msg || "Unable to load billing cycle data. Please refresh and try again.");
    }
  };

  return {
    billingCycleData,
    getBillingCycleData,
    billingCycleLoading,
  };
};

export default useFetchBillingCycle;
